import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_Autosave = _resolveComponent("Autosave")
  const _component_Loader = _resolveComponent("Loader")
  const _component_TenantGeneral = _resolveComponent("TenantGeneral")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")
  const _component_TenantFeed = _resolveComponent("TenantFeed")
  const _component_TenantAf = _resolveComponent("TenantAf")
  const _component_TenantAi = _resolveComponent("TenantAi")
  const _component_TenantProducts = _resolveComponent("TenantProducts")
  const _component_TenantPs = _resolveComponent("TenantPs")
  const _component_TenantSkills = _resolveComponent("TenantSkills")
  const _component_ScrollBar = _resolveComponent("ScrollBar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tabs, {
      modelValue: $data.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.active) = $event)),
      class: "tabs",
      tabs: $data.tabs,
      bordered: "",
      "tab-position": "right"
    }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
    _createVNode(_component_ScrollBar, {
      fade: "",
      "bar-x-offset": "-1.1rem"
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" General settings "),
        ($data.active === 'general')
          ? (_openBlock(), _createBlock(_component_SettingsFrame, {
              key: 0,
              title: "General",
              description: "Settings below are applied for every user in tenant.",
              class: "frame"
            }, {
              right: _withCtx(() => [
                _createVNode(_component_Autosave, {
                  saving: $data.saving,
                  saved_at: $data.saved_at
                }, null, 8 /* PROPS */, ["saving", "saved_at"])
              ]),
              default: _withCtx(() => [
                ($data.loading)
                  ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_TenantGeneral, {
                      key: 1,
                      store: $data.store,
                      onUpdate: $options.onUpdate
                    }, null, 8 /* PROPS */, ["store", "onUpdate"]))
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Feed settings "),
        ($data.active === 'feed')
          ? (_openBlock(), _createBlock(_component_SettingsFrame, {
              key: 1,
              title: "Feed",
              description: "Settings below are applied for every user in tenant.",
              class: "frame"
            }, {
              right: _withCtx(() => [
                _createVNode(_component_Autosave, {
                  saving: $data.saving,
                  saved_at: $data.saved_at
                }, null, 8 /* PROPS */, ["saving", "saved_at"])
              ]),
              default: _withCtx(() => [
                ($data.loading)
                  ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_TenantFeed, {
                      key: 1,
                      store: $data.store,
                      onUpdate: $options.onUpdate
                    }, null, 8 /* PROPS */, ["store", "onUpdate"]))
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Auto Follow settings "),
        ($data.active === 'auto_follow')
          ? (_openBlock(), _createBlock(_component_SettingsFrame, {
              key: 2,
              title: "Auto Follow",
              description: "Settings below are applied for every user in tenant.",
              class: "frame"
            }, {
              right: _withCtx(() => [
                _createVNode(_component_Autosave, {
                  saving: $data.saving,
                  saved_at: $data.saved_at
                }, null, 8 /* PROPS */, ["saving", "saved_at"])
              ]),
              default: _withCtx(() => [
                ($data.loading)
                  ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_TenantAf, {
                      key: 1,
                      store: $data.store,
                      onUpdate: $options.onUpdate
                    }, null, 8 /* PROPS */, ["store", "onUpdate"]))
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" AI Settings "),
        ($data.active === 'ai')
          ? (_openBlock(), _createBlock(_component_SettingsFrame, {
              key: 3,
              title: "AI Settings",
              description: "Settings below are applied for every user in tenant.",
              class: "frame"
            }, {
              right: _withCtx(() => [
                _createVNode(_component_Autosave, {
                  saving: $data.saving,
                  saved_at: $data.saved_at
                }, null, 8 /* PROPS */, ["saving", "saved_at"])
              ]),
              default: _withCtx(() => [
                ($data.loading)
                  ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_TenantAi, {
                      key: 1,
                      store: $data.store,
                      onUpdate: $options.onUpdate
                    }, null, 8 /* PROPS */, ["store", "onUpdate"]))
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Catalog "),
        ($data.active === 'catalog')
          ? (_openBlock(), _createBlock(_component_SettingsFrame, {
              key: 4,
              title: "Catalog",
              description: "Import the Install Base product catalog for this tenant.",
              class: "frame"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TenantProducts, { tenant: $props.tenant }, null, 8 /* PROPS */, ["tenant"])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Preferred Sources "),
        ($data.active === 'preferred_sources')
          ? (_openBlock(), _createBlock(_component_SettingsFrame, {
              key: 5,
              title: "Preferred Sources",
              description: "Settings below are applied for every user in tenant.",
              class: "frame"
            }, {
              right: _withCtx(() => [
                _createVNode(_component_Autosave, {
                  saving: $data.saving,
                  saved_at: $data.saved_at
                }, null, 8 /* PROPS */, ["saving", "saved_at"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_TenantPs, {
                  store: $data.store,
                  onUpdate: $options.onUpdate
                }, null, 8 /* PROPS */, ["store", "onUpdate"])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        ($data.active === 'skills')
          ? (_openBlock(), _createBlock(_component_SettingsFrame, {
              key: 6,
              title: "Skills & Sources",
              description: "Choose which skills and sources are available for this tenant.",
              class: "frame"
            }, {
              right: _withCtx(() => [
                _createVNode(_component_Autosave, {
                  saving: $data.saving,
                  saved_at: $data.saved_at
                }, null, 8 /* PROPS */, ["saving", "saved_at"])
              ]),
              default: _withCtx(() => [
                ($data.loading)
                  ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_TenantSkills, {
                      key: 1,
                      store: $data.store,
                      onUpdate: $options.onUpdate
                    }, null, 8 /* PROPS */, ["store", "onUpdate"]))
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}